import { I18nService } from "@perxis-auto/shared";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { sortEquipmentGroupsMap } from "./sortEquipmentGroupsMap.js";
function formatOptions(data, options = { onlyDifferences: false }) {
  const { i18n } = I18nService.getInstance();
  const { optionsMatrix, optionGroupsMap } = data;
  const { onlyDifferences = false } = options;
  const equipmentGroupsMap = {};
  const allComparedOptions = optionsMatrix.flat().filter((option, index, self) => index === self.findIndex((o) => o.id === option.id));
  const comparedOptionIdsMatrix = optionsMatrix.map((options2) => options2.map((option) => option.id));
  for (const option of allComparedOptions) {
    if (!option.group) {
      continue;
    }
    const group = optionGroupsMap[option.group.id];
    if (!group) {
      continue;
    }
    if (!equipmentGroupsMap[group.id]) {
      equipmentGroupsMap[group.id] = {
        id: group.id,
        title: group.data.alternateName ?? group.data.name,
        items: [],
        position: group.data.position
      };
    }
    const items = [];
    for (let comparedIndex = 0; comparedIndex < optionsMatrix.length; comparedIndex++) {
      const comparedOptionIds = comparedOptionIdsMatrix[comparedIndex];
      if (!comparedOptionIds.includes(option.id)) {
        items[comparedIndex] = null;
      } else {
        items[comparedIndex] = {
          id: option.id,
          label: option.displayName ?? option.name,
          value: true,
          formattedValue: i18n.t("common.booleanValues.trueValue", { ns: APP.name }),
          position: option.position
        };
      }
    }
    if (!items.length || !items.some((item) => item)) {
      continue;
    }
    const itemIds = items.map((item) => item == null ? void 0 : item.id);
    if (onlyDifferences && optionsMatrix.length > 1 && (/* @__PURE__ */ new Set([...itemIds])).size < 2) {
      continue;
    }
    equipmentGroupsMap[group.id].items.push(items);
  }
  return sortEquipmentGroupsMap(equipmentGroupsMap);
}
export {
  formatOptions
};
